import React from 'react';
import withStore from "@/hocs/withStore";
import isEmpty from 'is-empty';
import PriceMinimum from "@/Pages/All/PriceMinimum";
import CardModelImage from "@/Pages/All/CardModelImage";
import StyledRating from "@/Pages/All/StyledRating";
import LinkLoad from "@/Layouts/LinkLoad";
import Svg from "@/Pages/All/Svg";
import {declOfNum} from "@/Helpers/Function";

const CardModel = (props) => {
    const {el = {}, stores = {}} = props;
    const {buyOneClickStore = {}, profileStore = {}} = stores;

    const {card_price = null, price = 0, status = null} = el;

    let ratingAVG = 0;
    if (!isEmpty(el.ratingAVG)) {
        ratingAVG = Number(el.ratingAVG)
    }

    const Price = () => {
        let result = '';
        if (card_price !== null) {
            result = <>
                <div className={`priceContainer__priceCurrent`}>
                    {Number(card_price).toLocaleString('ru')} ₽
                </div>
                <div className={`priceContainer__priceOld`}>
                    {Number(price).toLocaleString('ru')} ₽
                </div>
            </>
        } else if (card_price === null) {
            result = <div className={`priceContainer__priceCurrent`}>Предзаказ</div>
        } else {
            result = <div className={`priceContainer__priceCurrent`}>
                {Number(card_price).toLocaleString('ru')} ₽
            </div>
        }

        return <div className={`priceContainer priceContainer_model`}>
            {result}
            {el.card_discount && card_price !== null && (
                <div className={`priceContainer__discount`}
                     style={{
                         color: `${el.marker_discount_color}`,
                         backgroundColor: `${el.marker_discount_bg_color}`
                     }}
                >
                    {`-${el.card_discount}%`}
                </div>
            )}
            {/*<div className={`cardModel__star`}>*/}
            {/*    <StyledRating ratingAVG={ratingAVG} />*/}
            {/*    {el.ratingCount !== 0 && (*/}
            {/*        <span className={`star__feedback`}>{el.ratingCount}</span>*/}
            {/*    )}*/}
            {/*</div>*/}
            {el.ratingCount !== null ?
                <div className={`cardCatalog__rating`}>
                    <Svg id={`star`} className={`svg__cardCatalogStar`} />
                    <div className={`cardCatalog__averageRating`}>{ratingAVG}</div>
                    <div className={`cardCatalog__ratingDot`}></div>
                    <div className={`cardCatalog__countReviews`}>
                        {el.ratingCount} {declOfNum(el.ratingCount, [' отзыв', ' отзыва', ' отзывов'])}
                    </div>
                </div>
                :
                <div className={`cardCatalog__rating`}>
                    <Svg id={`star`} className={`svg__cardCatalogStarNotRating`} />
                    <p className={`cardCatalog__notRating`}>Нет оценок</p>
                </div>
            }
        </div>
    }

    const PriceMinimum = () => {
        const {minimumPriceColor = '', minimumPrice = 0, minimumPriceText = ''} = el;

        if (minimumPrice === 0) {
            return null
        }

        return <div className={`priceMinimumModelContainer`}>
            <div className={`priceMinimumModelContainer__price`} style={{'backgroundColor': minimumPriceColor}}>
                {minimumPrice.toLocaleString('ru')}&nbsp;₽
            </div>
            <div className={`priceMinimumModelContainer__text`} style={{'borderColor': minimumPriceColor}}>
                <p style={{'color': minimumPriceColor}}>
                    {minimumPriceText}
                </p>
                {/*<p style={{'paddingRight': '8px'}}>Самая выгодная цена</p>*/}
                {/*<p style={{'color': minimumPriceColor, 'textDecoration': 'underline'}}>Как получить?</p>*/}
                {/*<Svg id={`arrows-right`} className={`svg__priceMinimumProductIcon`}*/}
                {/*     style={{'fill': minimumPriceColor}} />*/}
            </div>
        </div>
    }

    return <>
        <div key={el.id} className={`cardModel__item cardModel__item_${el.id}`}>
            <CardModelImage {...props} />
            <div className={`cardModel__content`}>
                <p className={`cardModel__title`}>{el.h1}</p>
                <Price />
                <PriceMinimum {...props} />
                <div className={`buttons buttons__model`}>
                    <LinkLoad href={`/catalog/product/${el.article}`} className={`btn btn__moreDetailedModel`}>
                        Подробнее
                        <Svg id={`arrows-right`} className={`svg__arrow-forward svg__arrow-forward_model`} />
                    </LinkLoad>
                    {status !== null && (
                        <>
                            {card_price === null ?
                                <button className={`btn btn__white btn__addWaitListModel`}
                                        onClick={() => profileStore.getSizeWaitList(el.id)}>
                                    В лист ожидания
                                </button>
                                :
                                <button className={`btn btn__white btn__buy-one-click-model`}
                                        onClick={() => buyOneClickStore.openModal(el.id)}>
                                    Купить в 1 клик
                                </button>
                            }
                        </>
                    )}
                </div>
            </div>
        </div>
    </>
}

export default withStore(CardModel);
